import { LANGUAGE_CODES, VALIDATION_KEYS } from "@fysaro/shared";
import { z } from "zod";

// DTO para crear
export const createExerciseCategorySchema = z.object({
  id: z.string().uuid().optional().nullable(),
  name: z.string().min(1, VALIDATION_KEYS.EXERCISE_CATEGORY.NAME_REQUIRED),
  description: z.string().max(200, VALIDATION_KEYS.EXERCISE_CATEGORY.MAX_LENGTH).optional().or(z.literal("")),
  color: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, "Color inválido").default("#3b82f6"),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  key: z.string().optional().nullable(),
});

// DTO para actualizar
export const updateExerciseCategorySchema = z.object({
  name: z.string().min(1, VALIDATION_KEYS.EXERCISE_CATEGORY.NAME_REQUIRED).optional(),
  description: z.string().max(200, VALIDATION_KEYS.EXERCISE_CATEGORY.MAX_LENGTH).optional().or(z.literal("")),
  color: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, "Color inválido").default("#3b82f6"),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  key: z.string().optional().nullable(),
});

export const createExerciseCategoryTranslationSchema = z.object({
  id: z.string().uuid().nullable(),
  name: z.string().min(1, VALIDATION_KEYS.EXERCISE_CATEGORY.NAME_REQUIRED),
  description: z.string().max(200, VALIDATION_KEYS.EXERCISE_CATEGORY.MAX_LENGTH).optional().or(z.literal("")),
  color: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, "Color inválido").default("#3b82f6"),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  key: z.string().optional().nullable(),
});